import React, { useEffect, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import Image from "../../Components/Reusable/Image";
import Collapse from 'react-bootstrap/Collapse';
import { ImageFilters } from "../../Utils/Enums";
import ApiService from "../../Services/ApiService";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import CustomDropDownReward from "../../Components/Reusable/CustomDropDownReward";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";

const FAQ = () => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [faqCategories, setFaqCategories] = useState([]);
  const [faqData, setFaqData] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [activecategory, setActiveCategory] = useState("");
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(9);

  useEffect(() => {
    // getFaqCategories();
    getFaqData();
  }, []);

  useEffect(() => {
    if (selectedCategoryId !== null) {
      getFaqData(selectedCategoryId, limit,offset);
    }
  }, [selectedCategoryId, limit,offset]);

  // const getFaqCategories = async () => {
  //   try {
  //     const response = await ApiService.getFaqcategory();
  //     setFaqCategories(response.faqCategory ?? []);
  //     if (response.faqCategory.length > 0) {
  //       setSelectedCategoryId(response.faqCategory[0].faq_category_id); // Automatically select the first category
  //     }
  //   } catch (error) {
  //     console.error('Error fetching FAQ categories:', error);
  //   }
  // };

  const getFaqData = async (categoryId, limit,offset) => {
    
    try {
      const response = await ApiService.getFaqdata(categoryId, limit,offset);      // Ensure the correct response structure
      setFaqCategories(response.data.faqCategoryData ?? []);
      setFaqData(response.data.faqsData);
      if (!selectedCategoryId && response.data.faqCategoryData.length > 0) {
        setSelectedCategoryId(response.data.faqCategoryData[0].faq_Category_id); // Automatically select the first category
      }
      setAvailableDataCount(response.availableDataCount);
    } catch (error) {
      console.error('Error fetching FAQ data:', error);
    }
  };

  const handleCategoryClick = (categoryId, categoryName) => {
    setSelectedCategoryId(categoryId);
    setSelectedIndex(-1); // Reset the selected question index when changing category
    setActiveCategory(categoryName)
    setOffset(0)

  };
  const handleDropdownChange = (selectedOption) => {
    const selectedCategory = faqCategories.find(category => category.faqCategoryName === selectedOption.value);
    if (selectedCategory) {
      setSelectedCategoryId(selectedCategory.faq_Category_id);
      setActiveCategory(selectedCategory.faqCategoryName);
    }
  };
  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner PageTitle={"Frequently Asked Questions"} breadCrumpPageTitle={"Frequently Asked Questions"} />
      <div className="text-content-page-container d-flex flex-column align-items-center">
        <h2 className="Heading fw-600 mb-0 headingColor text-center">
          Frequently Asked Questions
        </h2>
        <div className="w-100 categories-dropdown mt-4 d-block d-md-none">
          <CustomDropDownReward
            labelTitle=""
            id="category"
            name="category"
            placeholder="Select Category"
            options={faqCategories?.map((category) => ({ value: category.faqCategoryName, label: category.faqCategoryName }))}
            defaultOption={{
              value: activecategory || faqCategories[0]?.faqCategoryName,
              label: activecategory || faqCategories[0]?.faqCategoryName
            }}
            additionalclass={"Dropdownstylingblogs"}
            indicatorColor="black"
            onChange={(selectedOption) => handleDropdownChange(selectedOption)}
          />
        </div>

        <div className="sub-tabs d-flex gap-4 align-items-center mb-3 cursor-pointer">
          {faqCategories?.map((category, index) => (
            <h2
              key={index}
              className={`Sub-Heading text-uppercase mb-0 ${selectedCategoryId === category.faq_Category_id ? "category-tab-selected" : "category-tab"}`}
              onClick={() => handleCategoryClick(category.faq_Category_id, category.faqCategoryName)}>
              {category.faqCategoryName}
            </h2>
          ))}
        </div>
        {faqData?.length > 0 ? (
          <div className="d-flex flex-column w-100 gap-4">
            {faqData?.map((faq, faqIndex) => (
              <div className="faq-item d-flex flex-column" key={faqIndex}>
                <div className="d-flex align-items-center justify-content-between gap-3 cursor-pointer"
                  onClick={() => setSelectedIndex((faqIndex === selectedIndex) ? -1 : faqIndex)}>
                  <h2 className={`faq-question Sub-Heading mb-0 ${(faqIndex === selectedIndex) ? "fw-600 headingColor" : "fw-400 black"}`}>
                    {faqIndex + 1}. {faq.question}
                  </h2>
                  <Image className="faq-item-arrow" src={SvgImages.rightArrow}
                    style={{
                      rotate: (faqIndex === selectedIndex) ? "-90deg" : "0deg",
                      transition: "rotate 0.25s ease-out",
                      filter: (faqIndex === selectedIndex) ? ImageFilters.blue.filter : ImageFilters.black.filter
                    }} />
                </div>
                <Collapse in={faqIndex === selectedIndex}>
                  <p className="faq-answer Sub-Heading fw-400 black mt-3 mb-0">{faq.answer}</p>
                </Collapse>
              </div>
            ))}
            {generatePaginationFooter(
              availableDataCount,
              limit,
              offset,
              setOffset
            )}
          </div>

        ) :
          <div className=" text-center">
            <div className="d-flex justify-content-center">
              <Image src={PngImages.no_record} className="img-fluid" />
            </div>
            <p className="no-records-text sub-large-text-one fw-700 mb-0">No Faq Found...</p>
          </div>
        }

      </div>
    </div>
  );
};

export default FAQ;
